import AlertsApi from './Alerts.api';
import config from '../config';
import { targetingToAPI } from '../tasks/TaskTargeting.utils';

const { ALL_LANGUAGES } = config;

// One alerts_text row per tenant language. CTA copy is per language; an
// off switch sends null text and link for every language.
function alertToAPI(alert) {
  return {
    appearance: alert.appearance,
    icon: alert.icon,
    languages: ALL_LANGUAGES.map((language) => {
      const copy = alert.languages[language];
      return {
        language,
        title: copy.headline.trim(),
        copy: copy.details.trim(),
        cta_text: alert.cta_enabled ? copy.cta_text.trim() : null,
        cta_link: alert.cta_enabled ? copy.cta_link.trim() : null,
      };
    }),
    targeting: targetingToAPI(alert.targeting),
    start_date: alert.start?.toISOString() ?? null,
    end_date: alert.end?.toISOString() ?? null,
  };
}

export default {
  createAlert,
};

function createAlert(alert) {
  return AlertsApi.createAlert(alertToAPI(alert));
}
